import React, { useState } from "react";
import { formatDate } from "../../../PotentialLeads/Utils/TableHeadlist";
import { useUpdateAppointmentChangeStatusMutation } from "../../../../../Service/PatientList";
import { Modal, Button } from "react-bootstrap";

const AppoinmentHistory = ({ AppointmentData }) => {
  const upcomingAppointments =
    AppointmentData?.data?.upcomingAppointments || [];
  const pastAppointments = AppointmentData?.data?.pastAppointments || [];

  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [actionType, setActionType] = useState("");
  const [showModal, setShowModal] = useState(false);

  const [updateStatus, { isLoading }] =
    useUpdateAppointmentChangeStatusMutation();

  const formatDateTime = (dateStr, timeStr) => {
    const date = new Date(dateStr);
    const time = new Date(`1970-01-01T${timeStr}Z`);
    const formattedDate = new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    }).format(date);
    const formattedTime = new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    }).format(time);
    return { formattedDate, formattedTime };
  };

  const handleActionClick = (appointment, type) => {
    setSelectedAppointment(appointment);
    setActionType(type);
    setShowModal(true);
  };

  const handleConfirm = async () => {
    if (!selectedAppointment) return;

    try {
      await updateStatus({
        id: selectedAppointment.appointmentId, // ✅ use appointmentId from API response
        data: { statusInput: actionType },
      }).unwrap();

      // Close modal after success
      setShowModal(false);
      setSelectedAppointment(null);
      setActionType("");
    } catch (error) {
      console.error("Failed to update appointment:", error);
    }
  };

  return (
    <div className="p-2">
      {/* Upcoming Appointments */}
      <div>
        <span className="f-18 fw-400">Upcoming Appointments</span>
        <div>
          {upcomingAppointments.length > 0 ? (
            upcomingAppointments.map((appointment, index) => {
              const { formattedDate, formattedTime } = formatDateTime(
                appointment.appointmentDate,
                appointment.appointmentTime
              );
              return (
                <div className="card p-2 mt-2" key={index}>
                  <div className="d-flex justify-content-between">
                    <div className="d-flex gap-3">
                      <div>
                        <span className="material-symbols-outlined future d-flex justify-content-center">
                          today
                        </span>
                      </div>
                      <div className="d-flex flex-column gap-2">
                        <span className="f-18 fw-400">Next appointment</span>
                        <span className="f-21 fw-500">
                          <span className="material-symbols-outlined me-2">
                            stethoscope
                          </span>
                          {appointment.consultantName}
                        </span>
                        <span className="d-flex gap-2 f-21 fw-500">
                          <span className="d-flex align-items-center">
                            <span className="material-symbols-outlined me-2">
                              calendar_clock
                            </span>
                            {formattedDate}
                          </span>
                          <span className="d-flex align-items-center">
                            <span className="material-symbols-outlined me-2">
                              schedule
                            </span>
                            {formattedTime}
                          </span>
                        </span>
                      </div>
                    </div>

                    {/* Actions */}
                    <div className="d-flex flex-column justify-content-center align-items-end gap-2">
                      <span
                        style={{ color: "green", cursor: "pointer" }}
                        onClick={() =>
                          handleActionClick(appointment, "completed")
                        }
                      >
                        Completed
                      </span>
                      <span
                        style={{ color: "red", cursor: "pointer" }}
                        onClick={() => handleActionClick(appointment, "cancel")}
                      >
                        Cancel
                      </span>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="card p-2 mt-2 d-flex justify-content-center align-items-center">
              <span>No Upcoming Appointments!</span>
            </div>
          )}
        </div>
      </div>

      {/* Past Appointments */}
      <div className="mt-3">
        <span className="f-18 fw-400">Past Appointments</span>
        {pastAppointments.length > 0 ? (
          pastAppointments.map((appointment, index) => (
            <div key={index} className="card p-2 mt-2">
              <div className="d-flex gap-3">
                <div>
                  <span className="material-symbols-outlined past d-flex justify-content-center">
                    today
                  </span>
                </div>
                <div className="d-flex flex-column gap-2">
                  <span className="f-18 fw-400">
                    {formatDate(appointment.appointmentDate)}
                  </span>
                  <span className="f-21 fw-500">
                    Appointment With{" "}
                    <span style={{ color: "#0060FF" }}>
                      {appointment.consultantName}
                    </span>{" "}
                    at{" "}
                    <span style={{ color: "#0060FF" }}>
                      {appointment.appointmentTime}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="card p-2 mt-2 d-flex justify-content-center align-items-center">
            <span>No Past Appointments!</span>
          </div>
        )}
      </div>

      {/* Confirmation Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Update Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to {actionType} this appointment?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            No
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? "Updating..." : "Yes"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AppoinmentHistory;
